import { LocationDTO, SourceLocationDTO } from "../apiclient/ApiDtos";
import SearchCriteria, { TravellerType } from "./SearchCriteria";

export interface FieldError {
    name:string,
    message?:string
}

export default class SearchFormModel {
    sourceLocation: SourceLocationDTO | null;
    destinationLocation: LocationDTO | null;
    numberOfSeats: number;
    departureDate: string | null;
    travellerType: TravellerType | null;
    

    constructor(sourceLocation: SourceLocationDTO | null, destinationLocation: LocationDTO | null,
        departureDate: string | null, numberOfSeats: number, travellerType: TravellerType | null) {

        this.sourceLocation = sourceLocation;
        this.destinationLocation = destinationLocation;
        this.numberOfSeats = numberOfSeats;
        //this.departureDate = "2026-03-27";
        this.departureDate = departureDate;
        this.travellerType = travellerType;
    }

    isValid(): boolean {
        return this.sourceLocation != null && this.destinationLocation != null &&
            this.departureDate != null && this.travellerType != null;
    }

    validate(): FieldError[]{
        let errors:FieldError[] = [];   
        if(this.sourceLocation == null) {
            errors.push({name:'source'})
        }
        if(this.destinationLocation == null) {
            errors.push({name:'destination'})
        }
        if(this.departureDate == null) {
            errors.push({name:'departureDate'})
        }        
        if(this.travellerType == null) {
            errors.push({name:'travellerType'});
        }
        return errors;
    }

    toSearchCriteria(isSearchingSmallCar: boolean): SearchCriteria {
        if (this.isValid()) {
            return new SearchCriteria(<SourceLocationDTO>this.sourceLocation, <LocationDTO>this.destinationLocation,
                <string>this.departureDate, this.numberOfSeats, this.travellerType || 'Local', isSearchingSmallCar);
        }
        throw new Error('Search Form is invalid.');
    }

    restore(searchCriteria:SearchCriteria):void {
        this.sourceLocation = searchCriteria.sourceLocation;
        this.destinationLocation = searchCriteria.destinationLocation;
        this.numberOfSeats = searchCriteria.numberOfSeats;
        this.travellerType = searchCriteria.travellerType;
        this.departureDate = searchCriteria.isoDateString;
        //this.isSmallCar = searchCriteria.isSmallCar;
    }

    clear():void{
        this.sourceLocation = null;
        this.destinationLocation = null;
        this.numberOfSeats = 1;
        this.travellerType = 'Local';
        this.departureDate = null;
        //this.isSmallCar = false;
    }

    withUpdatedSourceAndDestination(source: SourceLocationDTO|null, destination: LocationDTO|null):void {
        this.sourceLocation = source;
        this.destinationLocation = destination;
        this.numberOfSeats = this.numberOfSeats;
        this.travellerType = this.travellerType;
        this.departureDate = this.departureDate;
        //this.isSmallCar = searchCriteria.isSmallCar;
    }

    //withIsSmallCar(isSmallCar: boolean) : void {
        //this.isSmallCar = isSmallCar;
    //}
}